export const styles = {
  popUpContainer: {
    backgroundColor: "black",
    color: "white",
    boxShadow: "24px",
    padding: "10px",
    margin: "0 10px 10px 0",
    width: "100%",
  } as const,
  progressContainer: {
    display: "flex",
    alignItems: "center",
  } as const,
  infoContainer: {
    display: "flex",
    width: "80%",
    alignItems: "center",
    justifyContent: "space-between",
  } as const,
  progressWrapper: {
    display: "flex",
    alignContent: "center",
    width: "100%",
    flexWrap: "wrap",
    justifyContent: "space-between",
    height: "100%",
  } as const,
  uploadingFilesDetailsListContainer: {
    position: "fixed",
    bottom: -8,
    left: "10px",
    padding: "16px",
    margin: "0 10px 10px 0",
    zIndex: 30000,
    borderRadius: "20px",
    width: "380px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    paddingTop: "5px",
    backgroundColor: "black",
  } as const,
  progressText: {
    fontSize: "14px",
    paddingTop: "5px",
    marginLeft: "10px",
  } as const,
  scrollBox: {
    maxHeight: "300px",
    overflow: "auto",
    overflowX: "hidden",
  } as const,
  topBar: {
    height: "30px",
    display: "flex",
    justifyContent: "space-between",
    alignContent: "center",
  },
};
